import { buildResource, clone } from './utils.helper';
export function allWithPlaceholder(list, placeholder) {
    if (placeholder === void 0) { placeholder = null; }
    var item = null;
    if (typeof placeholder === 'string')
        item = buildResource(0, placeholder);
    var items = clone(list);
    items.splice(0, 0, item);
    return items;
}
export function getResource(list, id) {
    return clone(list).find(function (item) { return item.$id === id; }) || null;
}
export function getManyResource(list, ids) {
    return clone(list).filter(function (item) { return ids.find(function (id) { return item.$id === id; }); });
}
export function prependResource(list, item) {
    addResource(list, item, 0);
    return list;
}
export function appendResource(list, item) {
    addResource(list, item);
    return list;
}
export function addResource(list, item, index) {
    if (index !== undefined) {
        list.splice(index, 0, item);
    }
    else {
        list.push(item);
    }
}
export function removeResource(list, id) {
    var index = clone(list).findIndex(function (item) { return item.$id === id; });
    if (index) {
        list.splice(index, 1);
    }
}
//# sourceMappingURL=resource.helper.js.map